import React from "react";

export const About = (): JSX.Element  => {
    return(
        <h1>About</h1>
    );
}